import getNodePlanData from './getNodePlanData';
import { calculateBasePrice } from './helperFunctions';
import AppState from '../AppState';
/**
 * Calculates and updates the price for a plan with no upgrade offers.
 *
 * @param {AvailableSelections} plan - The plan object containing the details.
 * @param {AvailableSelections} selectedPlan - The selected plan object.
 * @returns {Object} - The updated plan object with price, identifier, and discount details.
 */
const addPlanNoUpgrade = (plan, selectedPlan) => {
    var _a, _b;
    const { PlanIdentifier, OptionFee, PlanName, price } = plan;
    let priceUpdate = price;
    let planIdUpdate = PlanIdentifier;
    if (!['Standard', 'Standard Fixed Wireless'].includes(PlanName)) {
        const basePrice = calculateBasePrice(selectedPlan);
        priceUpdate = basePrice + OptionFee;
    }
    if (PlanName === 'Standard Fixed Wireless') {
        planIdUpdate = PlanIdentifier + 'W';
    }
    const planType = AppState.get('planType');
    const nodeData = getNodePlanData(planIdUpdate, planType);
    const discountArray = (plan === null || plan === void 0 ? void 0 : plan.ProductDescriptions) || [];
    const discountText = ((_a = discountArray[0]) === null || _a === void 0 ? void 0 : _a.Text) || '';
    const discountLabel = ((_b = discountArray[0]) === null || _b === void 0 ? void 0 : _b.Label) || '';
    const discountAmount = discountText !== '' ? Number(discountText) : 0;
    return {
        PlanIdentifier: planIdUpdate,
        PlanName: PlanName,
        ProductDescriptions: discountArray,
        price: priceUpdate,
        nodeData: nodeData,
        discount: {
            discountAmount: discountAmount,
            discountPrice: discountAmount !== 0 ? priceUpdate - discountAmount : 0,
            discountType: discountLabel,
        },
    };
};
export default addPlanNoUpgrade;
